import { ErrorBoundary } from "components/common/ErrorBoundary/ErrorBoundary";
import { MyAccountFooter } from "components/common/MyAccountFooter/MyAccountFooter";
import { MyAccountHeader } from "components/common/MyAccountHeader/MyAccountHeader";
import React from "react";

export const LocalStorageDisabled = () => {
  return (
    <ErrorBoundary>
      <MyAccountHeader />
      <div className="arc3-container">
        <div className="arc3-padding-xl">
          <h4>Please enable site data and cookies in your browser to use the website</h4>
          <p>
            Your browser is currently set to block site data and cookies. In order to visit the website, you need to
            allow site data and cookies.
          </p>
          <p>
            Cookies and site data are files created by websites you visit. They make your online experience easier by
            saving browsing information. With cookies, sites can keep you signed in, remember your site preferences, and
            give you locally relevant content.
          </p>
        </div>
      </div>
      <MyAccountFooter />
    </ErrorBoundary>
  );
};
